import { jsx as _jsx } from "react/jsx-runtime";
import { useController, useFormContext } from 'react-hook-form';
import DropZone from './Dropzone';
const ControlledDropZone = ({ name, uploadedFileUrls = [], images = [], onRemoveFile, ...rest }) => {
    // Try to get form context, but handle SSR gracefully
    let form;
    try {
        form = useFormContext();
    }
    catch (e) {
        form = null;
    }
    if (!form) {
        if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
            console.warn(`ControlledDropZone "${name}" must be used inside a <FormProvider>. Rendering uncontrolled fallback.`);
        }
        return _jsx(DropZone, { images: images, fileUrls: uploadedFileUrls, ...rest });
    }
    const { field, fieldState } = useController({
        name,
        control: form.control,
    });
    return (_jsx(DropZone, { images: images, onRemoveFile: (fileName, id) => {
            onRemoveFile?.(fileName, id);
            form.clearErrors(fileName);
        }, fileUrls: uploadedFileUrls, value: field.value, onChange: field.onChange, error: fieldState.error, ...rest }));
};
export default ControlledDropZone;
